class BaseUrlConfigStore {
  baseUrl: string;
  constructor(baseUrl?) {
    this.baseUrl = baseUrl;
  }

  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getBaseUrl() {
    return this.baseUrl;
  }
}

const BaseURLConfigStore = new BaseUrlConfigStore();

export default BaseURLConfigStore;
